const DownloadProgressModal = ({ show, progress, onCancel }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="modal">
            <div className="modal-content">
                <h2>レンダリング中...</h2>
                <div className="progress-bar-container">
                    <div className="progress-bar" style={{ width: `${progress}%` }}></div>
                </div>
                <button className="cancel-button" onClick={onCancel}>レンダリングを中止</button>
            </div>
        </div>
    );
};

export default DownloadProgressModal;
